(() => {
  function prepareInput(origTime) {
    let time = origTime;
    if (typeof time !== 'number') {
      return time;
    }
    if (time && time.toString().length <= 11) {
      time *= 1000;
    }

    return time;
  }

  angular
    .module('gm.common.filters')
    .filter('gmFormatDate', gmFormatDateFilter)
    .filter('gmFormatDateTime', gmFormatDateTimeFilter)
    .filter('gmFormatTimeRemaining', gmFormatTimeRemainingFilter);

  function gmFormatDateFilter(
    $window
  ) {
    'ngInject';

    const formatDate = (input) => {
      const date = $window.moment(prepareInput(input));

      return date.format('ll');
    };

    formatDate.$stateful = true;
    return formatDate;
  }

  function gmFormatDateTimeFilter($window) {
    const formatDateTime = (input, shortMode = false) => {
      const date = $window.moment(prepareInput(input));

      return shortMode ? date.format('LLL') : date.format('LLL [GMT] Z');
    };

    formatDateTime.$stateful = true;
    return formatDateTime;
  }

  function gmFormatTimeRemainingFilter($window) {
    const formatDate = (input) => {
      const destination = $window.moment().add(input, 'seconds');

      return destination.fromNow(true);
    };

    formatDate.$stateful = true;
    return formatDate;
  }
})();
